module.exports = __webpack_public_path__ + "static/media/mouse-coupon.627fe7fd.png";